export default __webpack_public_path__ + "static/media/css.212d777a.svg";